import _ from "lodash";
import React from "react";

import { Field, reduxForm } from "redux-form";

import * as SelectTypes from "../../../constants/RepeatAppointmentDataTypes";

import RepeatAppointmentRepeatModal from "./RepeatAppointmentRepeatModal";
import RepeatAppointmentConfirmModal from "./RepeatAppointmentConfirmModal";

import { connect } from "react-redux";
import bindActions from "../../../helpers/bindActions";
import * as chartActions from "../../../actions/chartActions";
import DeleteImage from "../../../assets/images/appointment/btn-delete.png";
import { SelectPicker } from "../../select-picker/SelectPicker";
import BtnRepeatImage from "../../../assets/images/appointment/btn-repeat.png";
import BtnRepeatGreenImage from "../../../assets/images/appointment/btn-repeat-green.png";

const enhancer = connect(null, bindActions({ chartActions }));
const form = reduxForm({
  form: "repeatAppointment",
});

class RepeatAppointmentFollowAfter extends React.Component {
  handleRepeatClick = (index, repeatClickType, id) => {
    if (repeatClickType === "repeat")
      this.props.chartActions.repeatAppointmentRepeatModalShow(index);
    else {
      this.props.chartActions.repeatAppointmentSetDeleteId(id);
      this.props.chartActions.repeatAppointmentConfirmModalShow();
    }
  };

  handleDeleteClick = () => {
    this.props.chartActions.repeatAppointmentConfirmModalHide();
    this.props.chartActions.repeatAppointmentDeleteAfter();
  };

  render() {
    const {
      disabled,
      repeatAppointmentList,
      repeatAppointment,
      repeatAppointmentRepeatModalVisible,
      repeatAppointmentConfirmModalVisible,
      repeatAppointmentRepeatModalMode,
      repeatAppointmentRepeatModalDate,
      repeatAppointmentRepeatModalIndex,
      repeatAppointmentClickedRepeatArray,
      repeatAppointmentDeleteId,
    } = this.props;

    let selectOptions = SelectTypes.SelectValues.map((item) => ({
      value: item.code,
      label: item.name,
    }));

    let itemsOptions = [];

    if (repeatAppointment && repeatAppointment.values && repeatAppointment.values.mainSelect) {
      itemsOptions = SelectTypes.DataTypes[repeatAppointment.values.mainSelect].map((item) => ({
        value: item.value,
        label: item.label,
      }));
    }

    let list = [];

    if (!_.isEmpty(repeatAppointmentList)) {
      list = repeatAppointmentList.map((item, index) => {
        let btnRepeatSelectClassName = "btn btn-repeat-repeat";
        let repeatClickType = "repeat";
        let src = BtnRepeatImage;

        if (repeatAppointmentClickedRepeatArray.indexOf(item.id) !== -1) {
          repeatClickType = "delete";
          btnRepeatSelectClassName += " btn-repeat-repeat-selected";
          src = BtnRepeatGreenImage;
        }

        return (
          <div className="clearfix" key={index}>
            <div className="col-sm-2">
              <button
                type="button"
                disabled={disabled}
                onClick={() => {
                  this.handleRepeatClick(index, repeatClickType, item.id);
                }}
                className={btnRepeatSelectClassName}
              >
                <img src={src} height={32} alt="" />
              </button>
            </div>
            <div className="col-sm-3">
              <div className="repeat-appointment-item-after">
                <div className="Select-placeholder">{item.period}</div>
                <span className="Select-arrow-zone">
                  <span className="Select-arrow" />
                </span>
              </div>
            </div>
            <div className="col-sm-5">
              <div className="repeat-appointment-item-after">
                <div className="Select-placeholder">{item.periodUnit && item.periodUnit.name}</div>
                <span className="Select-arrow-zone">
                  <span className="Select-arrow" />
                </span>
              </div>
            </div>
            <div className="col-sm-2">
              <button
                type="button"
                disabled={disabled}
                onClick={() => {
                  this.handleRepeatClick(index, "delete", item.id);
                }}
                className="btn btn-repeat-delete"
              >
                <img src={DeleteImage} className="img-responsive" alt="" />
              </button>
            </div>
          </div>
        );
      });
    }

    return (
      <div className="repeat-appointment-main-block">
        <div className="repeat-appointment-list clearfix">{list}</div>
        <div className="repeat-appointment-after-form">
          <div className="col-sm-4">
            <Field
              component={({ input }) => (
                <SelectPicker
                  value={{ value: input.value }}
                  disabled={disabled}
                  options={itemsOptions}
                  placeholder="--"
                  onChange={(x) => input.onChange(x.value)}
                />
              )}
              name="mainItem"
              id="mainItem"
            />
          </div>
          <div className="col-sm-8">
            <Field
              name="mainSelect"
              id="mainSelect"
              component={({ input }) => (
                <SelectPicker
                  placeholder="Choose period"
                  options={selectOptions}
                  disabled={disabled}
                  value={{ value: input.value }}
                  onChange={(x) => input.onChange(x.value)}
                />
              )}
            />
          </div>
          <div className="col-sm-12">
            <button
              type="button"
              disabled={disabled}
              onClick={this.props.chartActions.repeatAppointmentSaveAfter}
              className="btn btn-primary"
            >
              Add
            </button>
          </div>
        </div>
        <RepeatAppointmentRepeatModal
          show={repeatAppointmentRepeatModalVisible}
          repeatAppointmentRepeatModalMode={repeatAppointmentRepeatModalMode}
          repeatAppointmentRepeatModalDate={repeatAppointmentRepeatModalDate}
          repeatAppointmentList={repeatAppointmentList}
          index={repeatAppointmentRepeatModalIndex}
        />
        <RepeatAppointmentConfirmModal
          text="Are you sure you want to delete this entry? This action cannot be undone."
          handleClose={this.props.chartActions.repeatAppointmentConfirmModalHide}
          handleOK={() => {
            this.handleDeleteClick(repeatAppointmentDeleteId);
          }}
          show={repeatAppointmentConfirmModalVisible && !disabled}
        />
      </div>
    );
  }
}

export default enhancer(form(RepeatAppointmentFollowAfter));
